export default __webpack_public_path__ + "static/media/handshake.3d9bd869.svg";